import type { PeriodReview } from '../../../frontend-contract/types';

export function turnWasCalculated(result: { review: PeriodReview | null }): boolean {
  return result.review !== null;
}
